import React, { useEffect, useState } from "react";
import "./EffluentSummary.scss";
import { convertUnitsFinal } from "../../../../utils/dataAndFormulas/effluentForms";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { formatWhole, formatPercentage } from "../../../../utils/numberFormat";

const EffluentSummary = ({
  filters,
  site,
  valueBaseline,
  useAuth,
  effluentController,
  totales, // ✅ nuevo prop
  selectorSlot,
  exportSlot,
}) => {

    const { translations } = useLanguage();
    const t = (key) => translations[key] || key;

  const [data, setData] = useState({
    total: 0,
    reutilizados: 0,
    industrial: 0,
    domestico: 0,
    intensidad: 0,
    combinado: 0,
  });

  const [results, setResults] = useState({});

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getMonthName = (monthNumber) => {
    // monthNumber viene 1..12
    return monthNames[monthNumber - 1] || "";
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // console.log(
        //   "📊 Totales recibidos en ResumenEnergia:",
        //   totales,
        //   filters
        // );

        // ✅ PRIORIDAD 1: usar los datos ya calculados en EffluentKPIsDashBoard
        if (totales && Object.keys(totales).length > 0) {
          setResults(totales);

          const getInM3 = (kpi, source) => {
            if (!kpi) return 0;
            return kpi.unit === "m3"
              ? kpi.total
              : convertUnitsFinal(kpi.total, kpi.unit, "m3", source);
            //return kpi.total;
          };

          const total_domestic_effluents = getInM3(
            totales?.total_domestic_effluents_kpis?.[filters.year],
            "total_domestic_effluents_kpis"
          );
          const total_industrial_effluents = getInM3(
            totales?.total_industrial_effluents_kpis?.[filters.year],
            "total_industrial_effluents_kpis"
          );
          const total_combined_effluents = getInM3(
            totales?.total_combined_effluents_kpis?.[filters.year],
            "total_combined_effluents_kpis"
          );
          const total_sludge_and_mud = getInM3(
            totales?.sludge_and_mud?.[filters.year],
            "sludge_and_mud"
          );
          const total_recycled_effluents = getInM3(
            totales?.recycled_effluents?.[filters.year],
            "recycled_effluents"
          );

          const toNumber = (v) => (Number.isFinite(v) ? v : 0);

          const total =
            toNumber(total_domestic_effluents) +
            toNumber(total_industrial_effluents) +
            toNumber(total_combined_effluents) +
            toNumber(total_sludge_and_mud) +
            toNumber(total_recycled_effluents);

         console.log("rrr",
            total_domestic_effluents,
            total_industrial_effluents,
            total_combined_effluents,
            total_sludge_and_mud,
            total_recycled_effluents
          ); 
          setData({
            total,
            reutilizados: total_recycled_effluents,
            industrial: total_industrial_effluents,
            domestico: total_domestic_effluents,
            combinado: total_combined_effluents,
            intensidad: 0,
          });
          return; // ✅ salimos, no hace falta fetch
        }
      } catch (error) {
        console.error("❌ Error al traer resumen de energía:", error);
      }
    };

    fetchData();
  }, [filters, site, valueBaseline, effluentController, totales]);

  // --- Cálculo de Porcentajes ---
  const percentReutilizados =
    data.total > 0 ? (data.reutilizados / data.total) * 100 : 0;
  const percentIndustrial =
    data.total > 0 ? (data.industrial / data.total) * 100 : 0;
  const percentDomestico =
    data.total > 0 ? (data.domestico / data.total) * 100 : 0;
  const percentCombinado =
    data.total > 0 ? (data.combinado / data.total) * 100 : 0;

  const resumenItems = [];

  // Efluente Total siempre
  resumenItems.push({
    title: t("total_effluent"),
    //subtitle:"(unidad de medida:  m3)",
    value: data.total,
    unit: "M3",
    secondary: "",
    progress: null,
    color: "#c52914",
    hasProgress: false,
  });

  // Efluentes reutilizados siempre
  resumenItems.push({
    title: t("effluent_reused"),
    //subtitle:"(unidad de medida:  m3)",
    value: data.reutilizados,
    unit: "M3",
    secondary: formatPercentage(percentReutilizados),
    progress: percentReutilizados,
    color: "#c52914",
    hasProgress: true,
    //legend:"La línea refleja el porcentaje entre efluentes reutilizadas / sobre el Total de agua"
  });

  // Si hay valor en combinado y no hay en doméstica ni industrial
  if (data.combinado && !data.domestico && !data.industrial) {
    resumenItems.push({
      title: t("combined_effluents"),
      // subtitle:"(unidad de medida:  m3)",
      value: data.combinado,
      unit: "M3",
      secondary: "",
      progress: null,
      color: "#c52914",
      hasProgress: false,
      legend: "",
    });
  } else {
    // Si hay valores en industrial o doméstico
    if (data.industrial) {
      resumenItems.push({
        title: t("industrial_effluent"),
        //subtitle:"(unidad de medida:  m3)",
        value: data.industrial,
        unit: "M3",
        secondary: formatPercentage(percentIndustrial),
        progress: percentIndustrial,
        color: "#c52914",
        hasProgress: true,
        // legend:"La línea refleja el porcentaje entre efluentes industriales/ sobre el Total de efluentes"
      });
    }

    if (data.domestico) {
      resumenItems.push({
        title: t("domestic_effluent"),
        value: data.domestico,
        // subtitle:"(unidad de medida:  m3)",
        unit: "M3",
        secondary: formatPercentage(percentDomestico),
        progress: percentDomestico,
        color: "#c52914",
        hasProgress: true,
        //legend:"La línea refleja el porcentaje entre efluentes domésticos/ sobre el Total de efluentes"
      });
    }
  }

  // --- Renderizado ---
  return (
    <div className="resumen-grid">
      {resumenItems.map((item, index) => (
        <div
          key={index}
          className={`resumen-card-col${index === 0 ? " resumen-card-col--first" : ""}`}
        >
          <div className={`resumen-slot-row${index === resumenItems.length - 1 ? " resumen-slot-row--right" : ""}`}>
            {index === 0 && selectorSlot}
            {index === resumenItems.length - 1 && exportSlot}
          </div>
          <div
            className={`resumen-card effluent-card  ${!item.hasProgress ? "no-progress" : ""}`}
          >
            <div className="card-meta">
              <div className="card-title-row">
                <span className="card-title">{item.title}</span>
              </div>
              <div>
                {item.subtitle && (
                  <span className="card-subtitle">{item.subtitle}</span>
                )}
              </div>
            </div>

            <div className="card-header">
              <span className="card-value">
                {formatWhole(item.value)}
                <span className="card-unit">{item.unit}</span>
              </span>
              {item.secondary && (
                <div className="percentage-text">{item.secondary}</div>
              )}
            </div>

            {item.hasProgress && (
              <div className="progress-container">
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{
                      width: `${Math.round(item.progress || 0)}%`,
                      backgroundColor: item.color || "#648EBC",
                    }}
                  />
                </div>
              </div>
            )}

            <div className="empty-space"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EffluentSummary;
